module.exports = __webpack_public_path__ + "img/trendingUp-white.e186a973.svg";